import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Callout, RowsSkeletonLoader } from '@node-space/ui-components'
import { useRecurringExportContext } from 'hooks/context/useRecurringExportContext'
import { useReportScheduleQuery } from 'hooks/queries/useReportScheduleQuery'
import { RecurringExportSteps } from 'types/transactionsExport'
import { ReportScheduleItem } from './ReportSchedule'

export const RecurringExportList = () => {
  const { t } = useTranslation()
  const [isDeleteError, setIsDeleteError] = useState(false)
  const { walletId, setStep } = useRecurringExportContext()
  const { data: reportSchedules = [], isFetching, isError } = useReportScheduleQuery(walletId, true)

  useEffect(() => {
    if (!isFetching && !isError && !reportSchedules?.length) {
      setStep(RecurringExportSteps.FORM)
    }
  }, [isFetching, isError, reportSchedules])

  return (
    <Box flex flexCol gap={16}>
      {isFetching && <RowsSkeletonLoader rows={1} />}
      {isError && !isFetching && (
        <Callout variant="error">{t('exports.scheduledReportsError')}</Callout>
      )}
      {!isFetching && !isError && (
        <Box tag="table">
          {reportSchedules?.map((reportSchedule, i) => {
            return (
              <ReportScheduleItem
                key={reportSchedule?.id}
                hideTitle={i > 0}
                reportSchedule={reportSchedule}
                setIsDeleteError={setIsDeleteError}
              />
            )
          })}
        </Box>
      )}
      {isDeleteError && <Callout variant="error">{t('exports.deleteReportScheduleError')}</Callout>}
    </Box>
  )
}
